import {ExperimentEnum, BookEnum, LandingEnum} from "_business";
import {setRegister} from ".";

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

/**
 * Deep merge two objects.
 * @param target
 * @param sources
 */

// let ix = 0;
export function mergeDeep(target, ...sources) {
  // console.log('mergeDeep', target, sources)
  // ix++; if (ix > 100) return target;

  if (!sources.length)
    return target;

  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key])
          Object.assign(target, { [key]: {} });

        mergeDeep(target[key], source[key]);
      } else
        Object.assign(target, { [key]: source[key] });
    }
  }

  return mergeDeep(target, ...sources);
}

/**
 * Up timer.
 * @param callback
 * @param timeout
 */
export function upTimer(callback, timeout = 300) {
  if (window.upTimer) {
    clearTimeout(window.upTimer);
    delete window.upTimer;
  }

  window.upTimer = setTimeout(callback, timeout);
}

/**
 * Copy object.
 * @param obj
 */
export function cloneDeep(obj) {
  return JSON.parse(JSON.stringify(obj));
}

/**
 * Is IOS.
 */
export function isIos() {
  const ua = navigator.userAgent.toLowerCase()
  return /i(Phone|Pad|Pod)/i.test(ua) || /^((?!chrome|android).)*safari/.test(ua)
}

export function isChrome() {
  const ua = navigator.userAgent.toLowerCase()
  return /chrome/.test(ua) && !/edge|edg|opr|brave|firefox|samsungbrowser/.test(ua)
}

/**
 * First letter lowercase.
 * @param string
 */
export function toFirstLower(string) {
  if (!string)
    return string

  return string.replace(/(?:^|\s)\S/g, (a) => {
    return a.toLowerCase()
  })
}

/**
 * First letter upcase.
 * @param str
 */
export function toFirstUp(str) {
  return str ? str.charAt(0).toUpperCase() + str.slice(1) : str
}

/**
 * Interval fetching.
 * @param url
 * @param data
 * @param callback
 * @param method
 * @param callbackError
 */
export const dataFetch = async (url, data, callback, method = 'POST', callbackError) => {

  const repeatCallback = (error, message) => {
    setTimeout(() => {
      // mixpanel.track(error, {message})
      dataFetch(url, data, callback, method, null)
    }, 1000)
  }

  try {
    const response = await fetch(url, method === 'POST' ? {
      method,
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(data)
    } : undefined)

    if (!response?.ok) {
      console.error(response)

      if (callbackError)
        callbackError(response)

      repeatCallback('Server Error', `${response?.status} ${response?.statusText}`)
      return
    }

    const dataJson = await response.json()

    callback && callback(dataJson)
  } catch (err) {
    console.error(err)

    if (callbackError)
      callbackError(err)

    repeatCallback('Catch Error', `${err?.message}`)
  }
}

/**
 * First letter lowercase.
 * @param name
 * @param defaultValue
 * @param storage
 */
export function getItem(name, defaultValue = [], storage = window.localStorage) {
  try {
    return (JSON.parse(storage.getItem(name)) || defaultValue)
  } catch (e) {
    console.error(e)
  }

  return defaultValue
}

/**
 * Set session.
 * @param props
 */
export function setSession(props) {
  window.sessionStorage.setItem('session_uid', window.session_uid)

  dataFetch(
    process.env.REACT_APP_API_URI + 'web-sessions',
    {
      ...props,
      session_uid: window.session_uid,
      version: process.env.REACT_APP_VERSION,
      quiz: window.quiz,
      landing: window.landing,
    },
    (response) => {
      // response.country_code = 'UG'
      if (response.country_code) {
        window.sessionStorage.setItem('country_code', response.country_code)
        window.updateCountry && window.updateCountry(response.country_code)
      }

      // response.ask_consent = true

      // setTimeout(() => {
      //   console.log('response.ask_consent', response.ask_consent)
        window.sessionStorage.setItem('ask_consent', response.ask_consent ? '2' : '1')
        window.askConsent && window.askConsent(response.ask_consent)
      // }, 4000)
    }
  )
}

/**
 * Get experiment.
 * @param name
 * @param defaultValue
 * @param simulate
 */
export function getExperiment(name, defaultValue = null, simulate = false) {
  const values = ExperimentEnum[name]

  // if (!values)
  //   return null

  if (
    !values
    // Array.isArray(values) && values.length === 0 ||
    // typeof values === 'object' && Object.keys(values).length === 0
  ) {
    defaultValue = 'A'
    window.sessionStorage.removeItem(name)
  }

  const experiment = {name, value: window.sessionStorage.getItem(name) || defaultValue}

  if (defaultValue)
    return experiment

  if (process.env.REACT_APP_DEBUG && (!simulate || experiment.value)) {
    let experiments = document.querySelector('#experiments');

    if (!experiments) {
      experiments = document.createElement('div');
      experiments.setAttribute('id', 'experiments');
      experiments.setAttribute('style', 'position: fixed; z-index: 100; bottom: 21px; left: 5px; line-height: 1;');
      document.body.append(experiments);
    }

    if (!document.querySelector(`#exp_${name}`)) {
      const buttons = [];

      const addButton = (name, item, value) => {
        const selected = 'class="gold" style="font-weight: bold; cursor: default"';
        const onclick = (name, item) => {
          return `onclick="window.sessionStorage.setItem('${name}', '${item}'); window.location.reload()"`;
        };

        buttons.push(`<em role="button" data-item="${item}" ${experiment.value === item ? selected : onclick(name, item)}>${item}${value ? '-' + value : ''}</em>`);
      }

      if (Array.isArray(values)) {
        // const value = Math.round(100 / values.length)

        for (const item of values)
          addButton(name, item)
      } else {
        for (const item in values)
          addButton(name, item, values[item])
      }

      experiments.innerHTML += `<div id="exp_${name}">${name}: ${buttons.join(', ')}</div>`
    }
  }

  if (experiment.value)
    return experiment

  if (Array.isArray(values))
    experiment.value = values[
      Math.floor(Math.random() * values.length)
    ]
  else {
    const total = Object.values(values).reduce((sum, val) => sum + val, 0)
    const rand = Math.random() * total

    let sum = 0

    for (const key in values) {
      sum += values[key]

      if (rand < sum) {
        experiment.value = key
        break
      }
    }
  }

  if (process.env.REACT_APP_DEBUG) {
    const item = document.querySelector(`#exp_${name} [data-item=${experiment.value}]`)

    if (item) {
      item.removeAttribute('onclick')
      item.setAttribute('class', 'gold')
      item.setAttribute('style', 'font-weight: bold; cursor: default')
    }
  }

  if (!simulate)
    setExperiment(experiment)

  return experiment
}

/**
 * Set experiment.
 * @param props
 */
export function setExperiment({name, value}) {
  console.log('experiment', {[name]: value})

  window.sessionStorage.setItem(name, value)

  setRegister({
    [name]: value
  })
}

export const scrollIntoViewWithOffset = (selector, offset = 0) => {
  // document.getElementById('payment').scrollIntoView({block: "start", behavior: 'smooth'})
  const el = document.querySelector(selector)

  if (!el)
    return

  const top =
    el.getBoundingClientRect().top -
    document.body.getBoundingClientRect().top -
    offset

  window.scrollTo({
    behavior: 'smooth',
    top
  })
}

export function setPrice(active, isReturn = false) {
  const data = {
    id: active.id,
    name: active.name,
    fullPrice: active.fullPrice,
    currency: active.currency,
    currencySymbol: active.currencySymbol,

    // full_price: active.book.full_price,
    // name: active.book.name,
    // price: active.book.price,
    // promo: active.book.promo,

    // ...active.book,
  }

  // const list = Object.keys(BookEnum)

  if (isReturn)
    return data

  for (const book of Object.values(BookEnum))
    data[book] = {
      full_price: active[book]?.full_price,
      name: active[book]?.name,
      price: active[book]?.price,
      promo: active[book]?.promo,
      old_price: active[book]?.old_price
    }

  // if (isReturn)
  //   return data

  window.sessionStorage.setItem(
    'price',
    JSON.stringify(data)
  )
}

export function isIndia() {
  const
    lang = navigator.language,
    // lang = 'en',
    tz = Intl?.DateTimeFormat?.()?.resolvedOptions?.()?.timeZone

  return (
    !['es', 'de', 'fr', 'ru', 'uk'].some(code => lang.startsWith(code)) && (
      tz === 'Asia/Kolkata' ||
      lang.startsWith('en-IN') || lang.startsWith('hi') ||
      window.sessionStorage.getItem('country_code') === 'IN'
    )
  )
}

export function existsTranslation(i18n, key, ns = 'common') {
  const lang = i18n.resolvedLanguage

  try {
    return (
      i18n.hasResourceBundle(lang, ns) &&
      key.split('.').reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : null), i18n.getResourceBundle(lang, ns))
    )
  } catch (ex) {
    return false
  }
}

export function getUrl(path) {
  return (
    ![LandingEnum.default, LandingEnum.charisma].includes(window.landing)
      ? `/${window.landing}`
      : ''
  ) + path
}

export function loadCss(href) {
  if (!document.querySelector(`link[href="${href}"]`)) {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = href
    document.head.appendChild(link)
  }
}

// export function isLandingLanguage(landing, lang) {
//   return (
//     landing === window.landing &&
//     LandingRelationsEnum[landing].includes(lang)
//   )
// }